const cashin = {
  REJECTED: {
    message: 'Rejected cashin attempt',
    code: 'CSI_1'
  },
  ACCOUNT_NOT_FOUND: {
    message: 'Bank account not found',
    code: 'CSI_2'
  },
  INVALID_DOCUMENT: {
    message: 'Invalid document number',
    code: 'CSI_3'
  },
  INCONSISTENT_DATA: {
    message: 'Inconsistent cashin data',
    code: 'CSI_4'
  },
  BLOCKED_ACCOUNT: {
    message: 'Blocked account',
    code: 'CSI_5'
  },
  TRANSACTION_NOT_SUPPORTED: {
    message: 'Transaction not supported',
    code: 'CSI_6'
  },
  INVALID_AMOUNT: {
    message: 'Invalid cashin amount',
    code: 'CSI_7'
  },
  DATE_LIMIT: {
    message: 'Cashin after date limit',
    code: 'CSI_8'
  },
  THIRD_PARTY_CASHIN_NOT_ALLOWED: {
    message: 'Third party cashin not allowed for this company',
    code: 'CSI_10'
  }
};

module.exports = cashin;
